var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "institution-card" }, [
    _c(
      "div",
      { staticClass: "logo-container" },
      [
        _c("el-image", {
          staticClass: "institution-logo",
          attrs: { src: _vm.cardData.logo, fit: "cover" },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "institution-info" }, [
      _c("div", { staticClass: "institution-box" }, [
        _c(
          "div",
          { staticClass: "info-item" },
          [
            _c("el-image", {
              staticClass: "item-icon",
              attrs: { src: _vm.TimeIcon },
            }),
            _c("label", [_vm._v("建校时间")]),
            _c("span", [_vm._v(_vm._s(_vm.cardData.found))]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "info-item" },
          [
            _c("el-image", {
              staticClass: "item-icon",
              attrs: { src: _vm.CategoryIcon },
            }),
            _c("label", [_vm._v("办校类型")]),
            _c("span", [_vm._v(_vm._s(_vm.cardData.level))]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "info-item" },
          [
            _c("el-image", {
              staticClass: "item-icon",
              attrs: { src: _vm.SchoolIcon },
            }),
            _c("label", [_vm._v("简介")]),
            _c("div", { staticClass: "item-content" }, [
              _c("span", [_vm._v(_vm._s(_vm.cardData.intro))]),
              _c(
                "div",
                {
                  staticClass: "read-more",
                  on: {
                    click: function ($event) {
                      _vm.showModal = true
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-arrow-down" }),
                  _c("div", { staticClass: "read-more-label" }, [
                    _vm._v("展开"),
                  ]),
                ]
              ),
            ]),
          ],
          1
        ),
      ]),
    ]),
    _vm.showModal
      ? _c("div", { staticClass: "institution-detail" }, [
          _c("div", { staticClass: "modal-container" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h2", [_vm._v("学校详情")]),
              _c("i", {
                staticClass: "el-icon-close close-btn",
                on: {
                  click: function ($event) {
                    _vm.showModal = false
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "detail-content" }, [
              _vm._v(_vm._s(_vm.cardData.intro)),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }